/** Skeleton sizes for shipment/container detail page header service provider UI. */
export const ServiceProviderHeaderLayout = {
  providerName: {
    width: '100px',
    height: '18px',
  },
  providerLink: {
    width: '80px',
    height: '18px',
    rounded: '2px',
  },
} as const
